import React from 'react'
import { Icon, notification } from 'antd'

interface INotificationAlert {
  key?: string
  message?: string | React.ReactNode
  description?: string | React.ReactNode
  variant?: 'info' | 'success' | 'warning' | 'error'
}

export const notificationAlert = ({
  key = '',
  message = '',
  description = '',
  variant = 'info'
}: INotificationAlert) => {
  let icon = {
    type: 'info-circle',
    color: ''
  }
  switch (variant) {
    case 'success':
      icon = {
        type: 'check-circle',
        color: '#28a745'
      }
      break

    case 'warning':
      icon = {
        type: 'warning',
        color: '#ffc107'
      }
      break

    case 'error':
      icon = {
        type: 'close-circle',
        color: '#dc3545'
      }
      break

    default:
      icon = {
        type: 'info-circle',
        color: '#007bff'
      }
      break
  }

  notification.open({
    key,
    message,
    description,
    icon: <Icon type={icon.type} style={{ color: icon.color }} />
  })
}
